module.exports = __webpack_public_path__ + "static/media/plan-you-spouse.6e58b22a.svg";